module.exports = __webpack_public_path__ + "img/img56.90287290.svg";